import { render, staticRenderFns } from "./WaiterProgressHistoryRegister.vue?vue&type=template&id=7ae395b4&scoped=true&lang=pug"
import script from "./WaiterProgressHistoryRegister.vue?vue&type=script&lang=ts"
export * from "./WaiterProgressHistoryRegister.vue?vue&type=script&lang=ts"
import style0 from "./WaiterProgressHistoryRegister.vue?vue&type=style&index=0&id=7ae395b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae395b4",
  null
  
)

export default component.exports